import React, { useState } from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";
import useModalActions from "../../hooks/useModalActions";
import config from "../../config";
import { useNavigate } from "react-router-dom";

export default function SupportSendedModal() {
  const { t } = useTranslation();
  const { closeModal } = useModalActions();
  const navigate = useNavigate();

  const onClose = () => {
    closeModal(MODAL_TYPES.SUPPORT_SENDED);
    navigate(-1);
  };

  return (
    <BaseModal
      onClose={onClose}
      title={t("modals.support_sended.desc")}
      eventTypeModal={MODAL_TYPES.SUPPORT_SENDED}
    />
  );
}
